/**
 * API v1 for FLEXI web portal
 * A sample description of FLEXI API version 1 for web portal.
 *
 * OpenAPI spec version: 1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export type ContractCategory = 'Undefined' | 'Commertion' | 'Distribution' | 'CombinedServices';

export const ContractCategory = {
    Undefined: 'Undefined' as ContractCategory,
    Commertion: 'Commertion' as ContractCategory,
    Distribution: 'Distribution' as ContractCategory,
    CombinedServices: 'CombinedServices' as ContractCategory
};